import { render } from "./ObbStore.vue?vue&type=template&id=299b6b70"
import script from "./ObbStore.vue?vue&type=script&lang=js"
export * from "./ObbStore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__